
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cars/[slug]",
      function () {
        return require("private-next-pages/cars/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cars/[slug]"])
      });
    }
  